// import _ from "lodash";
import { cacheFormAdd, cacheFormRemove, cacheFormLoad } from "Js/cacher";

export default {
  state: {
    id: 0,
    idWndwActive: 0,
    errorsValidation: {},
    windows: []
  },
  namespaced: false,
  actions: {
    LOG_ERRORS_VAL: ({ commit, state }, errorObj) => {
      commit("logErrorsVal", errorObj);
    },

    UPDATE_MODEL: ({ commit, state }, { model, ind }) => {
      commit("updateModel", { model, ind });
    },

    ADD_WINDOW: ({ commit, state }, action) => {
      commit("addWindow", action.options);
    },

    UPDATE_WINDOW: ({ commit, state }, wndw) => {
      let ind = _.findIndex(state.windows, { id: wndw.id });

      if (ind >= 0) {
        cacheFormRemove(state, ind) // clear old listeners before eadding new0
        commit("updateWindow", { wndw, ind }); // first page 
      }
      else {
        ind = 0
        commit("addWindow", wndw);
      }

      setTimeout(() => {
        cacheFormLoad(state, wndw, ind)
        cacheFormAdd(state, wndw, ind)
      }, "0");

    },

    REMOVE_WINDOW: ({ commit, state }, id) => {
      let ind = _.findIndex(state.windows, { id: id });
      cacheFormRemove(state, ind)
      commit("removeWindow", ind);
    }
  },

  getters: {
    getModals: state => {
      return state.windows.filter(wndw => wndw.type == "modal");
    },

    getWindows: state => {
      return state.windows;
    },

    getActiveWindow: state => {
      return state.idWndwActive;
    },

    getFormSchema: state => idWndw => {
      let ind = _.findIndex(state.windows, { id: idWndw })
      return ind < 0 ? {} : state.windows[ind].formSchema
    }
  },

  mutations: {
    addWindow: (state, wndw) => {
      wndw.id = _.clone(state.id);
      wndw.cacheRemove = [];
      state.idWndwActive = wndw.id;
      state.windows.push(wndw);
      state.id++;
      return;
    },

    removeWindow: (state, ind) => {
      state.windows.splice(ind, 1);
      state.idWndwActive = 0 // base parent wndw
      return;
    },

    updateWindow: (state, args) => {
      Vue.set(state.windows, args.ind, Object.assign(state.windows[args.ind], args.wndw));
      return;
    },

    updateModel: (state, args) => {
      Vue.set(state.windows[args.ind].formSchema, 'model', Object.assign(state.windows[args.ind].formSchema.model, args.model));
      return;
    },

    logErrorsVal: (state, errorObj) => {
      Object.assign(state.errorsValidation, errorObj);
      return;
    }
  }
};